import React, { useState } from 'react';
import './css/About.css';
import about_img from '../../src/components/assets/about.jpg';
import Footer from '../components/Footer/Footer';
import { FaIndustry, FaDollarSign, FaHandshake, FaChalkboardTeacher, FaTimes } from 'react-icons/fa';
import logo from '../../src/components/assets/logo2.1.png';

const About = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', query: '' });
  const [result, setResult] = useState("");

  const handleGetStartedClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending....");
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('query', formData.query);
    formDataToSend.append("access_key", "c717ccdb-e8e5-4638-b9da-ba5a150b4b88");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formDataToSend,
    }).then((res) => res.json());

    if (res.success) {
      setResult(res.message);
      setFormData({ name: '', email: '', query: '' });
    } else {
      setResult(res.message);
    }
  };

  return (
    <>
      <div className="about-wrapper">
        <div className="header-section">
          <h1 className="main-heading">About Us</h1>
        </div>

        <div className="info-section">
          <div className="image-box">
            <img src={about_img} alt="About" className="about-image" />
          </div>
          <div className="text-box">
            <h3 className="academy-title">MANDI HARIYANNA Academy</h3>
            <h2 className="subtitle">Nurturing Tomorrow's Leaders Today</h2>
            <p>
              At MH Academy, we believe in providing quality education at an affordable cost. Our courses are designed to offer industry-relevant skills with a focus on practical learning.
            </p>
            <p>
              We equip students with theoretical knowledge and hands-on experience, ensuring they leave ready to take on real-world challenges.
            </p>
            <p>
              Learn from experienced industry professionals and join a network of successful alumni.
            </p>
            <p>
              Join us at MH Academy to access world-class education and transform your career.
            </p>
          </div>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <FaIndustry size={40} color="#1e90ff" />
            <h4>Industry-Level Training</h4>
            <p>
              Our training matches today’s job market needs through hands-on projects and real-life case studies.
            </p>
          </div>
          <div className="feature-card">
            <FaChalkboardTeacher size={40} color="#1e90ff" />
            <h4>Best Courses</h4>
            <p>
              From programming to business, our ever-evolving courses help you stay ahead in your field.
            </p>
          </div>
          <div className="feature-card">
            <FaDollarSign size={40} color="#1e90ff" />
            <h4>Affordable Learning</h4>
            <p>
              Get quality education at affordable prices, with flexible payments and scholarships.
            </p>
          </div>
          <div className="feature-card">
            <FaHandshake size={40} color="#1e90ff" />
            <h4>Placement Assistance</h4>
            <p>
              Access exclusive job opportunities and career guidance from top industry experts.
            </p>
          </div>
        </div>

        <div className="cta-section">
          <h2>Start Your Journey Today</h2>
          <p>
            Ready to take the next step in your career? Join MH Academy and learn from the best.
          </p>
          <button className="cta-btn" onClick={handleGetStartedClick}>Get Started</button>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-backdrop" onClick={handleCloseModal}></div>
          <div className="modal-container">
            <button className="modal-close" onClick={handleCloseModal}><FaTimes size={24} /></button>
            <div className="modal-logo">
              <img src={logo} alt="Logo" className="modal-logo-img" />
            </div>
            <h3>Contact Us</h3>
            <form onSubmit={handleSubmit} className="modal-form">
              <label>Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Enter your name" />
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Enter your email" />
              <label>Query</label>
              <textarea name="query" value={formData.query} onChange={handleChange} required placeholder="Enter your query" />
              <button type="submit" className="submit-btn">Submit</button>
            </form>
            {result && <p className="form-result">{result}</p>}
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default About;